export const OBJECT_STORAGE_SERVICE_REQUIRED_EVENT = 'object-storage-service-required'

export const OBJECT_STORAGE_SERVICE_INACTIVE_DETAIL = 'Client has no active Object Storage service.'

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null && !Array.isArray(value)

export const isObjectStorageServiceInactiveError = (error: unknown): boolean => {
  if (!isRecord(error)) {
    return false
  }

  const response = isRecord(error.response) ? error.response : null
  const data = response && isRecord(response.data) ? response.data : error

  return data.service === 'None' && data.detail === OBJECT_STORAGE_SERVICE_INACTIVE_DETAIL
}
